var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header-left flex"},[(_vm.organization.logo)?_c('img',{staticClass:"logo",attrs:{"src":_vm.mixinQiniuImg(_vm.organization.logo)},on:{"click":_vm.goHome}}):_vm._e(),_c('p',{staticClass:"company-name",on:{"click":_vm.goHome}},[_vm._v(_vm._s(_vm.organization.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }